import { computed } from 'vue'
import type { ComputedRef } from 'vue'

import { usePermissionsStore } from '@/pinia-store/usePermissionsStore'
import { AuthorizationPermissions, AuthorizationResourcesAndSubjects } from '@/types/authorization'

/**
 * Pode ENVIAR registro de plantão (`attendance_emitting`) em algum recurso do
 * ds_attendance — escala, unidade ou empresa: as permissões descem pelo grafo
 * (empresa → unidade → escala), então exigir o recurso exato esconderia a ação de
 * quem emite para a própria unidade. É a mesma permissão que o FAB do Detalhes do
 * Plantão consulta para abrir o `AttendanceUploadModal`, e a das escritas do
 * emissor no backend (upload, reenvio, justificativa, comentário).
 *
 * Desde o perfil Extrator, LER a fila (`attendance_reading`) não implica mais
 * poder enviar: o extrator chega às mesmas telas e não pode ver ações de envio.
 *
 * Isto é UX, não segurança: a barreira real é o 403 do backend.
 */
export function useCanEmitAttendance(): ComputedRef<boolean> {
  const permissionsStore = usePermissionsStore()
  return computed(() =>
    [
      AuthorizationResourcesAndSubjects.DsAttendance,
      AuthorizationResourcesAndSubjects.DsAttendanceHealthUnit,
      AuthorizationResourcesAndSubjects.DsAttendanceCompany
    ].some((resourceType) =>
      permissionsStore.checkAnyRessources({
        permission: AuthorizationPermissions.AttendanceEmitting,
        resourceType
      })
    )
  )
}
